import React, { memo, useRef } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { Button, Spacer } from 'design-system';
import { ExpandableFloatingBarView } from 'design-system/ExpandableFloatingBar';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import ExpandableFloatingBarViewLogos from './ExpandableFloatingBarViewLogos';
const InvestUsageExpandableFloatingBar = ({ onPress, isInTab }) => {
    const styles = useStyles(styleSet);
    const expandableFloatingBarRef = useRef(null);
    return (<ExpandableFloatingBarView isInTab={isInTab} onPress={onPress} ref={expandableFloatingBarRef} title="Put your money to work" description="See what we have to offer" icon={<ExpandableFloatingBarViewLogos />}>
      <View style={styles.bodyContainer}>
        <Text Text-20 centered>
          Put your money to work
        </Text>
        <Spacer h={16}/>
        <Text TextThin-14 Secondary centered>
          Discover 25+ ETFs & funds and start your investment journey. Capital at risk.
        </Text>
        <Spacer h={24}/>
        <Button brand title="Get started" onPress={() => {
            expandableFloatingBarRef.current?.collapse();
            onPress();
        }}/>
      </View>
    </ExpandableFloatingBarView>);
};
const styleSet = createStyleSheets(() => ({
    bodyContainer: {
        paddingHorizontal: rem(16),
    },
}));
export default memo(InvestUsageExpandableFloatingBar);
